import { render, staticRenderFns } from "./pcgs.vue?vue&type=template&id=65e2c03a&scoped=true"
import script from "./pcgs.vue?vue&type=script&lang=js"
export * from "./pcgs.vue?vue&type=script&lang=js"
import style0 from "./pcgs.vue?vue&type=style&index=0&id=65e2c03a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e2c03a",
  null
  
)

export default component.exports